export default __webpack_public_path__ + "static/media/330_business03-es-web.0fad4416.png";